import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, Toast, ConfirmDialog],
    template: `
        <router-outlet></router-outlet>
        <p-toast position="top-right" />
        <p-confirmdialog />
    `
})
export class AppComponent {}
